import { Injectable } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { HelpDeskPage } from 'src/app/main/help-desk/help-desk.page';
import { Title } from '@angular/platform-browser';

@Injectable()
export class HelpDeskService {

  constructor(
    private modalController: ModalController,
    private alertController: AlertController,
    private titleService: Title
  ) { }

  async openHelpDeskPopup() {
    const modal = await this.modalController.create({
      component: HelpDeskPage
    });
    modal.onDidDismiss().then(async (param) => {
      if (
        param &&
        param.data &&
        param.data['didSend'] != null &&
        param.data['didSend'] == true
      ) {
        const alert = await this.alertController.create({
          header: 'Success',
          message: 'Message was sent to OACI Help Desk. Please watch your email for a response.',
          buttons: ['OK']
        });

        await alert.present();
      }
      this.titleService.setTitle('OACI - Home');
    });
    return await modal.present();
  }
  
}
